import { render, staticRenderFns } from "./CustomBuilder.vue?vue&type=template&id=1334b8ee&"
import script from "./CustomBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CustomBuilder.vue?vue&type=style&index=0&id=1334b8ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports